import * as portableFetch from 'portable-fetch'

let onUnauthorizedError = () => {}
let onForbiddenError = () => {}

const fetch = (url, init) => {
  return portableFetch(url, init).then(async (response) => {
    if (response.status === 401) {
      // 認証エラー
      onUnauthorizedError()
    } else if (response.status === 403) {
      // アクセスが拒否された
      onForbiddenError()
    } else if (response.status !== 200) {
      try {
        const data = (await response.body.getReader().read()).value
        const str = new TextDecoder().decode(data) //String.fromCharCode.apply(String, data)
        response.json = JSON.parse(str)
      } catch {}
    }
    return new Promise((resolve, reject) => {
      resolve(response)
    })
  })
}

export const setUnauthorizedErrorHandler = (handler) => {
  onUnauthorizedError = handler
}

export const setForbiddenErrorHandler = (handler) => {
  onForbiddenError = handler
}

export const defaultFetch = portableFetch

export default fetch
